module.exports = __webpack_public_path__ + "media/images/img-family-5-d5207a0e.jpg";